import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const QUERY_KEY = 'GET_MOBILE_APP_THEMES';


export interface Theme {
  id: string;
  name: string;
  mainColor: string;
  colorSchemaLink: string;
  logotypeLink: string;
  organizationPath: string;
  organizationId: number;
}

export interface ThemesListItem {
  key: string;
  title: string;
  color: string;
}

export const useMobileThemesQuery = () => {
  const { data, isLoading, isSuccess } = useQuery([QUERY_KEY], () => api.get(API_URL.MOBILE_THEMES));

  const formattedList = useMemo<Array<ThemesListItem>>(() => {
    const list = data?.data || [];
    return list.map((item) => ({
      key: `${item.id}`,
      title: item.name || '',
      color: item.main_color ? `${item.main_color}` : '',
    }));
  }, [data]);

  const formattedThemes = useMemo<Array<Theme>>(() => {
    const themes = data?.data || [];

    return themes.map(
      (theme): Theme => ({
        id: `${theme?.id}`,
        name: theme?.name || '',
        mainColor: theme?.main_color || '',
        colorSchemaLink: theme?.color_schema_link || '',
        logotypeLink: theme?.logotype_link || '',
        organizationPath: theme?.organization_path || '',
        organizationId: theme?.organization_id || 0,
      })
    );
  }, [data]);

  return {
    formattedThemes,
    formattedList,
    isLoading,
    isSuccess,
  };
};
